// Libraries
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */

/**
 * @class AccordionController
 * @extends Controller
 * @description Adds a toggle all control to an accordion.
 */
class AccordionController extends Controller {
    static targets = ['collapsible'];
    static values = { allShown: Boolean };

    /**
     * @method toggleAll
     * @description Toggle visibility of all collapsible targets.
     *
     * @return {void}
     */
    toggleAll(event) {
        if (this.allShownValue === false) {
            this.collapsibleTargets.forEach((answer) => {
                answer.classList.add('show');
            });
            event.target.textContent = 'Hide all';
            this.allShownValue = true;
        } else {
            this.collapsibleTargets.forEach((answer) => {
                answer.classList.remove('show');
            });
            event.target.textContent = 'Show all';
            this.allShownValue = false;
        }
    }
}

// Exports
export default AccordionController;
